import { Button } from '@/components/ui/button';
import { LogOut, Bell, Search, Menu, X } from 'lucide-react';
import { useSidebar } from '@/contexts/SidebarContext';
import { ThemeSwitcher } from '../theme-switcher';
import { useUserStore } from '@ekonavi/auth';
import { useNavigate } from 'react-router-dom';

const Header = () => {
	const { isSidebarOpen, toggleSidebar, isMobile } = useSidebar();
	const { logout } = useUserStore();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate('/auth#login');
	};

	return (
		<header className='h-16 bg-card border-b border-border flex items-center justify-between px-6'>
			<div className='flex items-center gap-4 flex-1'>
				{/* Mobile menu button and desktop toggle */}
				<Button
					variant='ghost'
					size='icon'
					onClick={toggleSidebar}
					className='flex-shrink-0'>
					{isMobile && isSidebarOpen ? <X className='h-5 w-5' /> : <Menu className='h-5 w-5' />}
				</Button>

				<div className='relative max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg'>
					<Search className='absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4' />
					<input
						type='text'
						placeholder='Search...'
						className='pl-10 pr-4 py-2 w-full min-w-0 rounded-lg border border-input bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring'
					/>
				</div>
			</div>

			<div className='flex items-center gap-2'>
				<ThemeSwitcher />

				<Button
					variant='ghost'
					size='icon'>
					<Bell className='h-5 w-5' />
				</Button>

				<Button
					variant='ghost'
					size='sm'
					onClick={handleLogout}
					className='hidden sm:flex items-center gap-2'>
					<LogOut className='h-4 w-4' />
					<span className='hidden md:inline'>Logout</span>
				</Button>

				{/* Mobile logout button */}
				<Button
					variant='ghost'
					size='icon'
					onClick={handleLogout}
					className='sm:hidden'>
					<LogOut className='h-4 w-4' />
				</Button>
			</div>
		</header>
	);
};

export default Header;